export class OrderProduct{
    name:string;
    qty:number;
    
}


// WEBPACK FOOTER //
// E:/Project/posSystem/src/app/pos/modals/orderproduct.model.ts